import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';

/**
 * FRU-24835: a reverse mortgage is only for the home the borrower lives in. "Yes" answers propertyUse as primary and moves on;
 * "No" stops with a pointer to the home equity options, and nothing is submitted.
 */
@Component({
    selector: 'app-reverse-residence',
    templateUrl: './reverse-residence.component.html',
    styleUrls: ['./reverse-residence.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class ReverseResidenceComponent extends ButtonStepComponent implements OnInit {
  title = 'Do you live in this home as your primary residence?';
  notPrimary = false;
  buttonList = [
    { text: 'Yes', value: 'primary', imageName: 'yes', default: true },
    { text: 'No', value: 'not_primary', imageName: 'no-x' },
  ];

  ngOnInit() {
    this.control = this.form.contains('propertyUse')
      ? this.form.get('propertyUse') as UntypedFormControl
      : new UntypedFormControl('', Validators.required);
    if (!this.form.contains('propertyUse')) { this.form.addControl('propertyUse', this.control); }
  }

  /** Never auto-answered: the form also keeps FAST mode off in the reverse flow, and this question stays the visitor's. */
  fastTry(): void { }

  submit(button: any, event?: Event): void {
    if (button && button.value === 'not_primary') {
      this.control.setValue('');
      if (!this.notPrimary) {
        this.analyticsService.trackEvent('RatesForm', 'reverse_not_primary', 'reverse');
      }
      this.notPrimary = true;
      return;
    }
    this.notPrimary = false;
    super.submit(button, event);
  }
}
